import styled from 'styled-components';
import { getBaseTheme } from '@Themes';
import BoldLabel from '@Components/UI/Label';

export const Title = styled(BoldLabel)`
    font-size: ${getBaseTheme().texts.sizes.s.fontSize};
    font-weight: 400;
    color: rgb(51, 51, 51);
    padding: ${getBaseTheme().spaces.default.xs} ${getBaseTheme().spaces.default.s};
`;

export const MetaDataContainerWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;

    .custom-toggle {
        flex-direction: row-reverse !important;
        justify-content: flex-end;
        margin-left: 10px;
        margin: 10px;
    }

    .toggle-checkbox {
        margin-right: 10px;
    }

    .InlinedFieldLabel {
        margin-left: 16px;
    }

    div[class*='SingleSelectDropdown'] {
        padding: ${getBaseTheme().spaces.default.xs} ${getBaseTheme().spaces.default.s};
    }
`;
